import PubSub from 'pubsub-js';
import { useEffect } from "react"

export const usePubSubEvent = (eventName, callback, deps = []) => {
  useEffect(() => {
    const token = PubSub.subscribe(eventName, callback)
    return () => PubSub.unsubscribe(token)
  }, deps)
}